import React, { forwardRef } from 'react';

const SectionContainer = forwardRef(function SectionContainer(
  {
    as: Tag = 'div',
    className = '',
    maxWidthClass = 'max-w-[402px]',
    children,
    ...rest
  },
  ref,
) {
  const classes = `w-full mx-auto ${maxWidthClass} ${className}`.trim();
  return (
    <Tag ref={ref} className={classes} {...rest}>
      {children}
    </Tag>
  );
});

export default SectionContainer;
